<template>
    <div class="modal-backdrop fade show" v-if="isVisibleShare"></div>
    <div class="modal fade" :class="{ show: isVisibleShare }" tabindex="-1" aria-labelledby="exampleModalLabel"
        style="display: block" aria-modal="true" role="dialog" v-if="isVisibleShare">
        <div class="modal-dialog modal-xl modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 m-0 justify-content-end">
                    <button class="btn-close" @click="closeModal">
                        <i class="ti ti-x"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container mt-4">
                        <Form ref="reportForm" @submit="handleSubmit" :validation-schema="schema">
                            <div class="row align-items-start border-bottom pb-3 mb-3"
                                v-for="(item, index) in assigned_data" :key="index">

                                <div class="col-md-4">
                                    <label class="col-form-label">Territory</label>
                                    <Field as="select" :name="'rows[' + index + '].territory_id'" class="form-select"
                                        v-model="item.territory_id" @change="getUsers(index)">
                                        <!-- :disabled="isEdit && !item.isNew" -->
                                        <option value="">----- Select Territory -----</option>
                                        <option v-for="ter in territories.filter(t =>
                                            !assigned_data.some((item, idx) =>
                                                idx !== index && item.territory_id === t.id
                                            )
                                        )" :key="ter.id" :value="ter.id">
                                            {{ ter.name }}
                                        </option>
                                    </Field>
                                    <ErrorMessage :name="'rows[' + index + '].territory_id'" class="text-danger" />
                                </div>

                                <div class="col-md-6">
                                    <label class="col-form-label">Users</label>
                                    <Field :name="'rows[' + index + '].users'" v-model="item.users" class="form-select">
                                        <multiselect v-model="item.users" :options="item.allUsers" :multiple="true"
                                            track-by="id" label="name" placeholder="Select users"
                                            class="form-control" />
                                    </Field>
                                    <ErrorMessage :name="'rows[' + index + '].users'" class="text-danger" />
                                </div>

                                <!-- Remove Button -->
                                <div class="col-md-1 text-end mt-4">
                                    <button type="button"
                                        v-if="((isEdit && assigned_data.length) || assigned_data.length > 1)"
                                        class="cross-btn" @click="removeRow(item.id || index)">
                                        <i data-v-505522fa="" class="ion-close-round text-danger"
                                        data-bs-toggle="tooltip" title="Delete Row"></i>
                                    </button>
                                </div>

                                <!-- Add Row Button -->
                                <div class="col-md-1 text-end mt-4" v-if="shouldShowAddButton(index)">
                                    <button class="cross-btn" @click="addRow">
                                        <i class="ion-plus-round text-danger" title="Add Row"></i>
                                    </button>
                                    <!-- :disabled="assigned_data.length >= territories.length" -->
                                </div>
                            </div>

                            <!-- Submit Button -->
                            <div class="text-end">
                                <button type="submit" class="btn btn-success">
                                    Submit
                                </button>
                            </div>
                        </Form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ErrorMessage, Field, Form } from 'vee-validate';
import { computed, onMounted, ref, watch } from 'vue';
import Multiselect from 'vue-multiselect';
import { emits } from 'vue3-tags-input';
import { useStore } from 'vuex';
import * as Yup from 'yup';

export default {
    components: {
        Multiselect,
        Form,
        Field,
        ErrorMessage

    },
    props: {
        isVisibleShare: {
            type: Boolean,
            default: false,
        },
        reportId: {
            type: String,
            default: '',
        },
        refreshId: {
            type: String,
            default: '',
        }
    },
    setup(props, { emit }) {

        const store = useStore();

        const isEdit = ref(false);

        const reportForm = ref(null); // for template ref
        const apiData = ref([])

        const territories = computed(() => store.getters['organisation/getTerritories']);
        // const computedSchema = computed(() => (!isEdit.value ? schema : null));

        const schema = Yup.object().shape({
            rows: Yup.array().of(
                Yup.object().shape({
                    territory_id: Yup.string().required('Territory is required'),
                    users: Yup.mixed()
                        .test(
                            'is-valid-territory',
                            'Please select at least one user.',
                            (value) => {
                                if (Array.isArray(value)) {
                                    return value.length > 0;
                                }
                                return !!value;
                            }
                        )
                        .required('Users is required.')
                })
            ),
        });

        const assigned_data = ref([]);

        const addRow = () => {
            assigned_data.value.push({
                id: '',
                territory_id: '',
                users: [],
                allUsers: [],
                isNew: true
            });
        };

        const removeRow = (id) => {
            const data = apiData.value.find(item => item.territory_id === id)
            if (data) {
                assigned_data.value = assigned_data.value.filter(item => item.territory_id !== id);
                handleSubmit(false);
            } else {
                assigned_data.value.splice(id, 1);
            }

        }

        const getUsers = async (currentIndex) => {
            const selectedTerritoryId = assigned_data.value[currentIndex].territory_id

            if (selectedTerritoryId) {
                try {
                    // Fetch the responsible users for the selected territory
                    const response = await store.dispatch('organisation/fetchTerritoryCompanyUsers', [selectedTerritoryId]);
                    // Only update the responsibles for the current row
                    assigned_data.value[currentIndex].allUsers = response || [];
                    assigned_data.value[currentIndex].users = ''; // Reset responsible selection
                } catch (error) {
                    console.error("Error fetching responsibles:", error);
                }
            } else {
                assigned_data.value[currentIndex].allUsers = [];
                assigned_data.value[currentIndex].users = '';
            }
        };

        // const shouldShowAddButton = (index) => {
        //     return (
        //         (assigned_data.value.length === 1 && index === 0) || // only one row
        //         (assigned_data.value.length > 1 && index === assigned_data.value.length) // last row when multiple
        //     );
        // };

        const shouldShowAddButton = (index) => {
            return (
                index === assigned_data.value.length - 1 && // last row
                assigned_data.value.length < territories.value.length // not all territories assigned
            );
        };

        const handleSubmit = async (isRemove = true) => {
            const finalPayload = {
                assigned_data: assigned_data.value
                    .filter((item) => item.territory_id && item.users.length)
                    .map((item) => ({
                        territory_id: item.territory_id,
                        users: item.users.map((u) => (typeof u === 'string' ? u : u.id)),
                    }))
            };
            let response;
            if (isEdit.value) {
                response = await store.dispatch('report/updateShareReport', {
                    reportId: props.reportId,
                    payload: finalPayload
                });
            } else {
                response = await store.dispatch('report/reportShare', {
                    reportId: props.reportId,
                    payload: finalPayload
                });
            }
            if (response.status && isRemove) {
                // emit('close');
                closeModal()
            } else {
                await fetchData()
            }
        };

        const closeModal = () => {
            assigned_data.value = [];
            emit('close');
        }

        // This will run when component mounts AND when reportId changes
        const fetchData = async () => {
            if (!props.reportId) return;

            try {
                await store.dispatch('organisation/fetchTerritories');
                const data = await store.dispatch('report/fetchShareReportData', props.reportId);
                apiData.value = data;
                if (data?.length) {
                    isEdit.value = true;
                    assigned_data.value = [];

                    await Promise.all(data.map(async (item) => {
                        const response = await store.dispatch(
                            'organisation/fetchTerritoryCompanyUsers',
                            [item.territory_id]
                        );

                        assigned_data.value.push({
                            id: item.territory_id,
                            territory_id: item.territory_id,
                            allUsers: response || [],
                            users: item.users || [],
                            isNew: false
                        });
                    }));
                }
                else {
                    isEdit.value = false;
                    assigned_data.value = [{
                        id: '',
                        territory_id: '',
                        users: [],
                        allUsers: [],
                        isNew: true
                    }];
                    // reportForm.value?.resetForm();
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        // Run on component mount
        onMounted(fetchData);

        // Also watch for reportId changes
        watch(() => props.refreshId, fetchData);

        return {
            territories,
            assigned_data,
            addRow,
            removeRow,
            handleSubmit,
            shouldShowAddButton,
            closeModal,
            getUsers,
            isEdit,
            schema,
            reportForm,
            // computedSchema,
            apiData
        };
    },
};
</script>

<style scoped>
.modal {
    display: block;
}

.multiselect {
    padding: 0 !important;
}

pre {
    font-size: 14px;
}

.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>